import { OrderRequestIn } from '../../../../../store/api';
import { cartConfig } from '../../../../../config';
import { http } from '../../../../../api/axios';

export const confirmCartCheckout = (data: OrderRequestIn): Promise<OrderRequestIn> => {
    return http.post(cartConfig().endpointConfirmOrder, data).then(res => res.data);
};
